import { render, staticRenderFns } from "./DatasourceDsTabConexions.vue?vue&type=template&id=1a58d36a&scoped=true&lang=pug"
import script from "./DatasourceDsTabConexions.vue?vue&type=script&lang=js"
export * from "./DatasourceDsTabConexions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a58d36a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a58d36a')) {
      api.createRecord('1a58d36a', component.options)
    } else {
      api.reload('1a58d36a', component.options)
    }
    module.hot.accept("./DatasourceDsTabConexions.vue?vue&type=template&id=1a58d36a&scoped=true&lang=pug", function () {
      api.rerender('1a58d36a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/DatasourceDsTabConexions.vue"
export default component.exports